import React from 'react';
import PropTypes from 'prop-types';
import { Label } from 'reactstrap';
import { Field } from 'redux-form';
import { connect } from 'react-redux';
import withEndpointAuthorization from '../../authorization/withEndPointAuthorization';
import { GET } from '../../../../config/permissions';
import { PREVENTIVE_TASK_PROJECTION_DEPARTMENT_ENDPOINT } from '../../../../config/endpoints';

export const PreventiveTaskProjectionDepartmentViewField = ({ onChange }) => (
  <Label>
    <Field
      name="view"
      component="input"
      type="radio"
      value="DEPARTMENT"
      onChange={onChange}
    />{' '}
    Mi departamento
  </Label>
);

PreventiveTaskProjectionDepartmentViewField.propTypes = {
  onChange: PropTypes.func,
};

PreventiveTaskProjectionDepartmentViewField.defaultProps = {
  onChange: null,
};

const connectedComponent = connect(
  null,
  null,
)(PreventiveTaskProjectionDepartmentViewField);

export default withEndpointAuthorization({
  url: PREVENTIVE_TASK_PROJECTION_DEPARTMENT_ENDPOINT,
  permissionType: GET,
})(connectedComponent);
